let audio = null;
const listeners = new Set();
let state = { playing: false, current: 0, duration: 0 };

function emit() {
  listeners.forEach((l) => l(state));
}

export function initMusic(src) {
  if (audio) return audio;
  audio = new Audio(src);
  audio.preload = "auto";
  audio.loop = true;
  audio.addEventListener("play", () => {
    state = { ...state, playing: true };
    emit();
  });
  audio.addEventListener("pause", () => {
    state = { ...state, playing: false };
    emit();
  });
  audio.addEventListener("timeupdate", () => {
    state = { ...state, current: audio.currentTime, duration: audio.duration || 0 };
    emit();
  });
  audio.addEventListener("ended", () => {
    state = { ...state, playing: false };
    emit();
  });
  return audio;
}

export function playMusic() {
  if (audio) audio.play().catch(() => {});
}

export function pauseMusic() {
  if (audio) audio.pause();
}

export function toggleMusic() {
  if (!audio) return;
  audio.paused ? playMusic() : pauseMusic();
}

export function subscribe(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}

export function getState() {
  return state;
}
